define('backbone.validators',[
    // Libs
    'underscore', 'backbone', 'moment', 'validate', 'utils',
    // services
    'services/api',
], function(
    _, Backbone, moment, validate, U,
    // services
    API
) {

    /**
     * Before using it we must add the parse and format functions
     *
     * @see https://validatejs.org/#validators-datetime
     */
    validate.extend(validate.validators.datetime, {
        /**
         * Takes a value and parse it to a unix timestamp.
         * @param {string} value - mostly string but can be anything except null.
         * @return {string} a unix timestamp.
         */
        parse: function(value, options) {
            options = options || {};
            var format = API.format[options.dateOnly ? 'date' : 'timestamp'];
            return moment(value, format).valueOf();
        },
        /**
         * Takes a unix timestamp and returns a formatted date.
         * @param {string} value - a unix timestamp.
         * @return {string} a formatted date.
         */
        format: function(value, options) {
            options = options || {};
            var format = options.format || API.format[options.dateOnly ? 'date' : 'timestamp'];
            return moment.utc(value).format(format);
        }
    });

    validate.validators.luhnCheck = function(value, options, key, attributes) {
        var sum = 0;
        for (var i = 0; i < value.length; i++) {
            var intVal = parseInt(value.substr(i, 1));
            if (i % 2 === 0) {
                intVal *= 2;
                if (intVal > 9) {
                    intVal = 1 + intVal % 10;
                }
            }
            sum += intVal;
        }

        if (sum % 10 !== 0) {
            return options.message;
        }
    };


    var BackboneValidators = {},
        Model = Backbone.Model;

    BackboneValidators.Model = Model.extend({

        _getErrors: function(attrs, options) {
            var errors = [],
                constraints = _.result(this, "validation", false);

            // validates a schema using validate.js
            if (constraints) {
                var validateErrors = validate(attrs, constraints, { format: "detailed" });
                if (validateErrors && validateErrors.length) {
                    errors = validateErrors;
                }
            }

            // validates with custom validate method on model
            if (this.validate) {
                var customErrors = this.validate(attrs, options) || null;
                if (customErrors) {
                    errors = errors.concat(customErrors);
                }
            }
            return errors;
        },

        /**
         * Applies validate.js constraints and triggers field specific invalid
         * events.
         * @param  {Object} attrs  specific attributes or model attributes by default.
         * @param  {Object} options validate to true to explicitely validate.
         * @return {Boolean}  false if invalid.
         */
        _validate: function(attrs, options) {
            options = options || {};
            if (!options.validate || !(this.validate || this.validation)) return true;

            attrs = _.extend({}, this.attributes, attrs);
            this.validationError = null;
            var silent = options.silent,
                errors = this._getErrors(attrs, options),
                hasError = errors.length > 0;

            if (hasError) {
                errors = validate.groupErrorsByAttribute(errors);
                _.each(errors, function(attr, index) {
                    if (options.singleError) {
                        errors[index] = validate.flattenErrorsToArray([attr[0]]);
                    } else {
                        errors[index] = validate.flattenErrorsToArray(attr);
                    }

                    // field specific error event
                    if (!silent) this.trigger('invalid:' + index, this, errors[index], options);
                }, this);

                this.validationError = errors;

                if (!silent) {
                    this.trigger('invalid', this, errors, _.extend(options, { validationError: errors }));
                }
            }
            return !hasError;
        }

    });
    Backbone.Model = BackboneValidators.Model;

    // Really important to ensure that the default collection creates the right
    // type of Model.
    Backbone.Collection.prototype.model = Backbone.Model;

});

